import DOMPurify from "dompurify";
import { cn } from "@/lib/utils";

export function RawText({
  children,
  className,
}: {
  children: string | undefined | null;
  className?: string;
}) {
  return (
    <div
      className={cn("prose whitespace-normal", className)}
      dangerouslySetInnerHTML={{
        __html: children ? DOMPurify.sanitize(children) : "--",
      }}
    />
  );
}
